<div class="card shadow-sm border-0 p-4">
  <div class="row g-3">

    <!-- Nom -->
    <div class="col-lg-6 col-md-6 col-sm-12">
      <label class="form-label fw-bold">
        Nom <span class="text-danger">*</span>
      </label>

      <input
        type="text"
        class="form-control"
        placeholder="Ex: Consultation générale"
        [(ngModel)]="motif.name"
        (ngModelChange)="_change()">

      <small
        class="text-danger"
        *ngIf="isSubmitted && !motif.name">
        Le nom est obligatoire.
      </small>
    </div>

    <!-- Nom Arabe -->
    <div class="col-lg-6 col-md-6 col-sm-12">
      <label class="form-label fw-bold">
        Nom Arabe
      </label>

      <input
        type="text"
        class="form-control"
        dir="rtl"
        placeholder="مثال: استشارة عامة"
        [(ngModel)]="motif.nameArabic"
        (ngModelChange)="_change()">
    </div>

    <!-- Couleur -->
    <div class="col-lg-6 col-md-6 col-sm-12">
      <label class="form-label fw-bold">
        Couleur
      </label>

      <div class="color-picker-container">

        <input
          type="color"
          [(ngModel)]="motif.color"
          (ngModelChange)="_change()">

        <span
          class="color-preview"
          [style.background]="motif.color">
        </span>

        <span class="color-code">
          {{ motif.color }}
        </span>

      </div>
    </div>

  </div>
</div>